import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

import { IJBPPlanning } from 'partner360/entities/planning/model'

import { IPartnerFinSobRow } from '../model/types'

import { OVERALL_CATEGORY } from './revenueAndSob/constants'

interface IPartnerFinSobRowGroupIdentity {
  partnerId: string
  offering: string
}

export const mapPartnerFinSobRowFromApi = (
  row: IJBPPlanning,
  group: IPartnerFinSobRowGroupIdentity
): IPartnerFinSobRow => {
  const isOfferingTotal = Boolean(row.IsTotal)

  return {
    partnerId: row.PartnerId ?? group.partnerId,
    offering: (row.ProgramTypes ?? group.offering) as ProgramTypes,
    category: isOfferingTotal ? OVERALL_CATEGORY : row.Category,
    subCategory: isOfferingTotal ? undefined : (row.SubCategory ?? undefined),
    l3Category: isOfferingTotal ? undefined : (row.L3Category ?? undefined),
    fYear: row.FYear,
    fQuarter: row.FQuarter,
    isActuals: Boolean(row.IsActuals),
    isTarget: Boolean(row.IsTarget),
    isQuota: Boolean(row.IsQuota),
    isDirect: Boolean(row.IsDirect),
    isRollUp: Boolean(row.IsRollUp),
    isNoSplit: Boolean(row.IsNoSplit),
    isPartnerCount: Boolean(row.IsPartnerCount),
    isCollapsed: row.IsCollapsed === undefined ? undefined : row.IsCollapsed === 1,
    smbFraction: row.SMBFraction ?? null,
    sob: row.SoB ?? null,
    totalSumNdp: row.SellThruSumUSDNdp ?? null,
    totalSumNdpLc: row.SellThruSumLCNdp ?? null,
    totalSumNet: row.SellThruSumUSDNet ?? null,
    totalSumNetLc: row.SellThruSumLCNet ?? null,
    totalSumTNet: row.SellThruSumUSDTNet ?? null,
    totalSumTNetLc: row.SellThruSumLCTNet ?? null,
    totalSumUTNet: row.SellThruSumUSDUTNet ?? null,
    totalSumUTNetLc: row.SellThruSumLCUTNet ?? null,
    finYoyGrowth: row.FinYoYGrowth ?? null,
    sobYoyGrowth: row.SobYoYGrowth ?? null,
  }
}
